export default "__VITE_ASSET__CCMhDds___"